/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SendRiskWelcomeDto } from '../models/SendRiskWelcomeDto';
import type { TestSendEmailDto } from '../models/TestSendEmailDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class TestEmailService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public testSend(
        requestBody: TestSendEmailDto,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/email/test-send',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public sendRiskAssessmentWelcome(
        requestBody: SendRiskWelcomeDto,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/email/send-risk-assessment-welcome-sv',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
